import type {PerkIntegrationSpec, PerkIntegrationStruct} from '@cohort/shared/apps/app';
import {z} from 'zod';

export const TypeformFormConfigSchema = z.object({
  formId: z.string().min(1, {message: 'errorRequired'}),
});
export type TypeformFormConfig = z.infer<typeof TypeformFormConfigSchema>;

export const TypeformFormStateSchema = z.object({});
export type TypeformFormState = z.infer<typeof TypeformFormStateSchema>;

export const TypeformFormAccessDataSchema = z.object({});
export type TypeformFormAccessData = z.infer<typeof TypeformFormAccessDataSchema>;

export const TypeformFormUsageDataSchema = z.object({
  responseId: z.string(),
});
export type TypeformFormUsageData = z.infer<typeof TypeformFormUsageDataSchema>;

const TypeformFormUsageDataForExportSchema = TypeformFormUsageDataSchema;
export type TypeformFormUsageDataForExport = z.infer<typeof TypeformFormUsageDataForExportSchema>;

export const TypeformFormExposedConfigSchema = TypeformFormConfigSchema;
export type TypeformFormExposedConfig = z.infer<typeof TypeformFormExposedConfigSchema>;

export type TypeformFormPerkIntegrationStruct = PerkIntegrationStruct<
  'typeform.form',
  TypeformFormConfig,
  TypeformFormExposedConfig,
  TypeformFormState,
  TypeformFormAccessData,
  TypeformFormAccessData,
  TypeformFormUsageData,
  TypeformFormUsageData,
  TypeformFormUsageDataForExport
>;

export const TypeformFormPerkIntegrationSpec: PerkIntegrationSpec<TypeformFormPerkIntegrationStruct> =
  {
    id: 'typeform.form' as const,
    configSchema: TypeformFormConfigSchema,
    exposedConfigSchema: TypeformFormExposedConfigSchema,
    stateSchema: TypeformFormStateSchema,
    accessDataSchema: TypeformFormAccessDataSchema,
    usageInputDataSchema: TypeformFormAccessDataSchema,
    internalUsageDataSchema: TypeformFormUsageDataSchema,
    exposedUsageDataSchema: TypeformFormUsageDataSchema,
    exposedUsageDataForExportSchema: TypeformFormUsageDataSchema,
    defaultMaxUsagesPerToken: 1,
    requiresMerchantConnection: true,
    localizedConfig: false,
  };
